import LeftSidebar from "./components/left-sidebar";
import TopBar from "./components/topbar";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
// import { ToastContainer } from "react-toastify";
import { Toaster } from 'react-hot-toast';
import "react-toastify/dist/ReactToastify.css";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import { useState, useEffect } from "react";
import Dashboard from "./pages/Dashboard";
import { useCookies } from "react-cookie";
import { JoinGroup } from "./components/Groups/JoinGroup";
import { useSelector } from "react-redux";
import Events from "./pages/Events";
import ForgotPasswordPage from "./pages/ForgetPassword/ForgotPasswordPage";
import PasswordReset from "./pages/ForgetPassword/PasswordReset";
import BackButtonHandler from "./components/BackButtonHandler";
import ScrollToTop from "./components/ScrollToTop";
import { Capacitor } from '@capacitor/core';
import SuperAdminPage from "./pages/SuperAdmin/SuperAdminPage";
import DevAdminDashboard from "./pages/DevAdminPage/DevAdminDashboard";
import ControlUsersPage from "./pages/DevAdminPage/ControlUsersPage";
import ControlSchemaPage from "./pages/DevAdminPage/ControlSchemaPage";
import ControlGroupsPage from "./pages/DevAdminPage/ControlGroupsPage";
import ControlPortalPage from "./pages/DevAdminPage/ControlPortalPage";

// import useCapacitorRedirect from "./utils/useCapacitorRedirect";
// import PullToReload from "./components/PullToReload/PullToReload";
function App() {
  const [cookies, removeCookie] = useCookies(["token"]);
  const [loading, setLoading] = useState(true);
  const profile = useSelector((state) => state.profile);
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const isCapacitor = Capacitor.isNativePlatform();

  useEffect(() => {
    const token = cookies.token;
    if (token && token !== undefined) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
    setLoading(false);
  }, [cookies.token]);

  const handleLogin = () => {
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    if (cookies.token) {
      // document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/login";
    }
    setIsLoggedIn(false);
  };

  if (loading) {
    return <div></div>;
  }

  return (
    <>

      <div className="App">
       <Toaster
  position="top-right"
  toastOptions={{
    duration: 3000,
    style: {
      marginTop: "78px", 
    },
  }}
/>
        <Router>
          <ScrollToTop />
          <BackButtonHandler />


          <Routes>


            {/* Login and Register Routes */}
            <Route
              path="/login"
              element={
                isLoggedIn ? <Navigate to="/home" replace /> : <LoginPage handleLogin={handleLogin} />
              }
            />
            <Route
              path="/register"
              element={
                isLoggedIn ? <Navigate to="/home" replace /> : <RegisterPage handleLogin={handleLogin} />
              }
            />

            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route
              path="/reset-password/:userId/:token"
              element={<PasswordReset />}
            />
            {/* Route for the base URL */}
            <Route
              path="/*"
              element={<LandingPage handleLogin={handleLogin} />}
            />

            {isLoggedIn && (
              <>
                {/* Home route for logged-in users */}
                <Route
                  path="/home/*"
                  element={<Dashboard handleLogout={handleLogout} />}
                />
                {profile.profileLevel === 0 &&
                  <>
                    <Route
                      path="/super-admin/*"
                      element={<SuperAdminPage />}
                    />

                    <Route
                      path="/dev-admin/*"
                      element={<DevAdminDashboard />}

                    />

                    <Route path="/dev-admin/users" element={<ControlUsersPage />} />
                    <Route path="/dev-admin/schema" element={<ControlSchemaPage />} />
                    <Route path="/dev-admin/portal" element={<ControlPortalPage />} />
                    <Route path="/dev-admin/groups" element={<ControlGroupsPage />} />
                  </>

                }
                <Route
                  path="/groups/:_id/invite/*"
                  element={
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <LeftSidebar />
                      <div style={{ marginLeft: "20%", width: "80%" }}>
                        <TopBar handleLogout={handleLogout} />
                        <JoinGroup />
                      </div>
                    </div>
                  }
                />
                <Route
                  path="/events/:_id/*"
                  element={
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <LeftSidebar />
                      <div style={{ marginLeft: "20%", width: "80%" }}>
                        <TopBar handleLogout={handleLogout} />
                        <Events />
                      </div>
                    </div>
                  }
                />
              </>
            )}

            {/* Catch-all route to redirect to LandingPage */}
            <Route
              path="/"
              element={isCapacitor ? <Navigate to="/login" replace /> : <LandingPage handleLogin={handleLogin} />}
            />
          </Routes>
        </Router>

      </div>
    </>
  );
}

export default App;
